import Auth from 'pages/auth'
import { Navigate } from 'react-router-dom'

export const publicRoutes = [
  {
    path: '/',
    element: <Auth />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]
